// extracted by mini-css-extract-plugin
export default {"cardHeaderIcon":"c-e_cM","cardHeaderIcon__content":"c-e_cN"};